var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11H12",
    stroke: "url(#paint0_linear_4878_18905)",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8L13 10.5L11 13",
    stroke: "url(#paint1_linear_4878_18905)",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.5H2",
    stroke: "url(#paint2_linear_4878_18905)",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6L1 3.5L3 1",
    stroke: "url(#paint3_linear_4878_18905)",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4878_18905",
    x1: -2.94533,
    y1: 10.645,
    x2: -2.20808,
    y2: 15.8644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3550DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27E9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4878_18905",
    x1: 10.2827,
    y1: 6.225,
    x2: 16.7091,
    y2: 7.8794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3550DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27E9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4878_18905",
    x1: -1.94533,
    y1: 3.145,
    x2: -1.20808,
    y2: 8.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3550DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27E9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4878_18905",
    x1: 0.282667,
    y1: -0.775,
    x2: 6.70912,
    y2: 0.879399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3550DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27E9F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchlogo);
export default __webpack_public_path__ + "static/media/searchlogo.1f6af695bd050da38937c47de5c364e0.svg";
export { ForwardRef as ReactComponent };